(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PremDiscDeleteController',PremDiscDeleteController);

    PremDiscDeleteController.$inject = ['$uibModalInstance', 'entity', 'PremDisc'];

    function PremDiscDeleteController($uibModalInstance, entity, PremDisc) {
        var vm = this;

        vm.premDisc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PremDisc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
